"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
      r,
      ar = [],
      e;

  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }

  return ar;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SzDateRangePicker = void 0;

var react_1 = __importStar(require("react"));

var react_calendar_1 = __importDefault(require("react-calendar"));

var classnames_1 = __importDefault(require("classnames"));

var SzIcon_1 = __importDefault(require("../SzIcon/SzIcon"));

require("./SzDateRangePicker.scss");

var SzTypographie_1 = __importDefault(require("../SzTypographie/SzTypographie"));

var SzButton_1 = __importDefault(require("../SzButton/SzButton"));

exports.SzDateRangePicker = function (props) {
  var value = props.value,
      selectRange = props.selectRange,
      toggle = props.toggle,
      _a = props.isOpen,
      isOpen = _a === void 0 ? false : _a;

  var leadingZero = function leadingZero(date) {
    var year = date.getFullYear();
    var month = ('0' + (date.getMonth() + 1)).slice(-2);
    var day = ('0' + date.getDate()).slice(-2);
    return year + "-" + month + "-" + day;
  };

  var isRangeWithValues = selectRange && Array.isArray(value) && value.length > 0;
  var start_date = isRangeWithValues && value[0] ? leadingZero(value[0]) : undefined;
  var end_date = isRangeWithValues && value[1] ? leadingZero(value[1]) : undefined;
  var next = react_1.default.createElement(SzIcon_1.default, {
    icon: "arrow-right-1",
    variant: "line"
  });
  var prev = react_1.default.createElement(SzIcon_1.default, {
    icon: "arrow-left-1",
    variant: "line"
  });

  var _b = __read(react_1.useState(isOpen), 2),
      display = _b[0],
      setDisplay = _b[1];

  var targetRef = react_1.useRef(null);
  var calendarClasses = classnames_1.default('w-100', {
    'position-absolute': toggle,
    'd-none': toggle && !display
  });

  var onClick = function onClick() {
    setDisplay(!display);
  };

  var eventOnClick = react_1.useCallback(function (e) {
    var _a;

    var _b = e.target,
        tagName = _b.tagName,
        parentNode = _b.parentNode,
        classList = _b.classList;
    var className = 'react-calendar__tile';
    var refContainTarget = (_a = targetRef.current) === null || _a === void 0 ? void 0 : _a.contains(e.target);

    if (tagName === 'ABBR') {
      var isContained = parentNode.classList.contains(className);

      if (isContained || selectRange && isRangeWithValues) {
        setDisplay(false);
      }
    }

    if (classList.contains(className) || !refContainTarget) {
      setDisplay(false);
    }
  }, [isRangeWithValues, selectRange]);
  react_1.useEffect(function () {
    if (toggle) {
      document.body.addEventListener('click', eventOnClick);
      return function () {
        document.removeEventListener('click', eventOnClick);
      };
    }

    return;
  }, [eventOnClick, targetRef, toggle]);

  var CalendarChevronIcon = function CalendarChevronIcon() {
    return react_1.default.createElement(SzButton_1.default, {
      icon: "calendar-3",
      variant: "tertiary",
      onClick: onClick,
      className: "sz-daterangepicker_input-button ml-auto"
    }, react_1.default.createElement(SzIcon_1.default, {
      icon: "arrow-down-1",
      variant: "bold",
      className: "small pt-2"
    }));
  };

  var inputWrapperClasses = classnames_1.default('sz-daterangepicker_input-group d-flex align-items-center justify-content-space-between border mb-2', {
    'p-1': selectRange
  });

  var RangeInputGroup = function RangeInputGroup() {
    return react_1.default.createElement("div", {
      className: inputWrapperClasses,
      onClick: onClick
    }, react_1.default.createElement(SzIcon_1.default, {
      icon: "calendar-3",
      variant: "line",
      className: "mx-3"
    }), react_1.default.createElement("input", {
      type: "date",
      name: "sz-daterange-start",
      value: start_date,
      className: "border-0 pt-1 mx-auto",
      readOnly: true
    }), react_1.default.createElement(SzIcon_1.default, {
      icon: "keyboard-arrow-right",
      variant: "line",
      className: "mx-3"
    }), react_1.default.createElement("input", {
      type: "date",
      className: "border-0 pt-1 mx-auto",
      name: "sz-daterange-end",
      value: end_date,
      readOnly: true
    }));
  };

  var InputGroup = function InputGroup() {
    return react_1.default.createElement("div", {
      className: inputWrapperClasses,
      onClick: onClick
    }, react_1.default.createElement("div", {
      className: "sz-daterangepicker_input-group-before"
    }, react_1.default.createElement(SzTypographie_1.default, {
      tag: "span",
      className: "mx-2"
    }, "Le")), react_1.default.createElement("div", {
      className: "sz-daterangepicker_input-group-after"
    }, react_1.default.createElement("input", {
      type: "date",
      name: "sz-datepicker",
      className: "border-0",
      value: value ? leadingZero(value) : undefined,
      readOnly: true
    })), react_1.default.createElement(CalendarChevronIcon, null));
  };

  return react_1.default.createElement("div", {
    ref: targetRef,
    className: "sz-daterangepicker position-relative"
  }, selectRange ? react_1.default.createElement(RangeInputGroup, null) : react_1.default.createElement(InputGroup, null), react_1.default.createElement(react_calendar_1.default, __assign({
    className: calendarClasses,
    nextLabel: next,
    prevLabel: prev
  }, props)));
};

exports.default = exports.SzDateRangePicker;